// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem } from 'components';
import React, { ReactElement } from 'react';
import './dangerousGoods.scss';
import { useTranslation } from 'react-i18next';
import { TransportDriverLicenseModel } from 'api/types/Transport';
import useCheckColor from 'store/hooks/useCheckColor';

interface Props {
  userId: number | null;
  dataTransportDangerousGoods: TransportDriverLicenseModel[] | null | undefined;
}

const TransportDangerousGoods = (props: Props): ReactElement => {
  const { userId, dataTransportDangerousGoods } = props;
  const { t } = useTranslation('employee');

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  return (
    <>
      {dataTransportDangerousGoods &&
      dataTransportDangerousGoods !== null &&
      Object.keys(dataTransportDangerousGoods)?.length > 0 ? (
        <Box
          id="userTransportDangerousGoodsBox"
          name={t('userTransportDangerousGoods.DangerousGoods')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <div className="userTransportDangerousGoodsContent">
            {Object.keys(dataTransportDangerousGoods)?.map((k) => {
              return (
                <DesktopItem
                  id="qualifications"
                  name={
                    dataTransportDangerousGoods?.[k]?.qualification?.description
                  }
                >
                  <>
                    {dataTransportDangerousGoods?.[k]?.qualificationNumber !==
                      null &&
                    dataTransportDangerousGoods?.[k]?.qualificationNumber !==
                      '' &&
                    dataTransportDangerousGoods?.[k]?.qualificationNumber !==
                      ' ' ? (
                      <div className="transportDangerousGoodsBox">
                        <div className="transportDangerousGoodsLabel">
                          {t('userTransportDangerousGoods.qualificationNumber')}
                        </div>
                        <div className="transportDangerousGoodsValue">
                          {
                            dataTransportDangerousGoods?.[k]
                              ?.qualificationNumber
                          }
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {dataTransportDangerousGoods?.[k]
                      ?.expirationQualificationDate !== null ? (
                      <div
                        className={`dateTransportDangerousGoodsBox ${checkColor(
                          dataTransportDangerousGoods?.[k]
                            ?.expirationQualificationDate,
                          'uprawnienia',
                          'adr'
                        )}`}
                      >
                        <div
                          className={`dateTransportDangerousGoodsLabel ${checkColor(
                            dataTransportDangerousGoods?.[k]
                              ?.expirationQualificationDate,
                            'uprawnienia',
                            'adr'
                          )}`}
                        >
                          {t(
                            'userTransportDangerousGoods.expirationQualificationDate'
                          )}
                        </div>
                        <div
                          className={`dateTransportDangerousGoodsValue ${checkColor(
                            dataTransportDangerousGoods?.[k]
                              ?.expirationQualificationDate,
                            'uprawnienia',
                            'adr'
                          )}`}
                        >
                          {
                            dataTransportDangerousGoods?.[k]
                              ?.expirationQualificationDate
                          }
                        </div>
                      </div>
                    ) : (
                      ''
                    )}

                    <div className="borderTop" />
                  </>
                </DesktopItem>
              );
            })}
          </div>
        </Box>
      ) : null}
    </>
  );
};

export default TransportDangerousGoods;
